import React from 'react';

const Version = ({ ver }: { ver: string | undefined }) => (
  <h1>
    {ver}
  </h1>
);

export default Version;
